export { Tabs } from './Tabs'
export type { TabsProps, TabItem } from './Tabs'
